import "./styles.scss"

export default function DxmlSpan({ text, cssStyle, editorFontDef }) {
    return (
        <span style={cssStyle} >
            <StrongComponent editorFontDef={editorFontDef}>
                <EmComponent editorFontDef={editorFontDef}>
                    <UComponent editorFontDef={editorFontDef}>
                        <SuperComponent editorFontDef={editorFontDef}>
                            {text}
                        </SuperComponent>
                    </UComponent>
                </EmComponent>
            </StrongComponent>
        </span>
    )
}

function StrongComponent({ editorFontDef, children }) {
    if (editorFontDef.Bold) {
        return (
            <strong >
                {children}
            </strong>
        )
    } else {
        return (
            <>
                {children}
            </>
        )
    }
}
function EmComponent({ editorFontDef, children }) {
    if (editorFontDef.Italic) {
        return (
            <em >
                {children}
            </em>
        )
    } else {
        return (
            <>
                {children}
            </>
        )
    }
}

function UComponent({ editorFontDef, children }) {
    if (editorFontDef.Ul) {
        return (
            <u>
                {children}
            </u>
        )
    } else {
        return (
            <>
                {children}
            </>
        )
    }
}

function SuperComponent({ editorFontDef, children }) {
    if (editorFontDef.Super) {
        return (
            <sup>
                {children}
            </sup>
        )
    } else {
        return (
            <>
                {children}
            </>
        )
    }
}